import api from './index';

/**
 * Company Users API
 * Handles all API calls related to company users (company staff)
 */

const buildQuery = (params = {}) => {
  const clean = Object.entries(params).reduce((acc, [k, v]) => {
    if (v !== undefined && v !== null && v !== '') acc[k] = v;
    return acc;
  }, {});
  const qs = new URLSearchParams(clean).toString();
  return qs ? `?${qs}` : '';
};

export const getCompanyUsers = async (params = {}) => {
  const response = await api.get(`/company/company-staff${buildQuery(params)}`);
  return response;
};

export const getUserLimitInfo = async () => {
  const response = await api.get('/company/company-staff/user-limit');
  return response;
};

export const getCompanyUserById = async (id) => {
  const response = await api.get(`/company/company-staff/${id}`);
  return response;
};

export const getCompanyUserActivity = async (id, params = {}) => {
  const response = await api.get(`/company/company-staff/${id}/activity${buildQuery(params)}`);
  return response;
};

export const getCompanyUserAttributions = async (id, params = {}) => {
  const response = await api.get(`/company/company-staff/${id}/attributions${buildQuery(params)}`);
  return response;
};

export const createCompanyUser = async (userData) => {
  const response = await api.post('/company/company-staff', userData);
  return response;
};

export const updateCompanyUser = async (id, userData) => {
  const response = await api.put(`/company/company-staff/${id}`, userData);
  return response;
};

export const setCompanyUserLoginAccess = async (id, status) => {
  const response = await api.patch(`/company/company-staff/${id}/login-access`, { status });
  return response;
};

export const deleteCompanyUser = async (id) => {
  const response = await api.delete(`/company/company-staff/${id}`);
  return response;
};
